var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "project__deliverable__component" } },
    [
      _c("HeaderControlsProjectDeliverableList", {
        attrs: { projectDeliverable: true, myWeek: false },
        on: {
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid listing" },
        [
          _c("DeliverablesInProjectList", {
            attrs: {
              filterQuery: _vm.filterQuery,
              myWeek: false,
              expandAll: _vm.expandAll
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }